import {MdNavigateBefore} from 'react-icons/md'
import CarouselIcon from './icon'

export default function CarouselPrevIcon() {
	return <CarouselIcon>
		<MdNavigateBefore size="40px" />
	</CarouselIcon>
}